import { api } from "./client";
import type { AppVersion, Paginated } from "./types";

export const releasesApi = {
  list: () => api.get<Paginated<AppVersion>>("/app/versions/").then((r) => r.data),
  upload: (
    payload: { version: string; changelog: string; is_minimum_required: boolean; apk_file: File },
    onProgress?: (percent: number) => void
  ) => {
    const body = new FormData();
    body.append("version", payload.version);
    body.append("changelog", payload.changelog);
    body.append("is_minimum_required", String(payload.is_minimum_required));
    body.append("apk_file", payload.apk_file);
    return api
      .post<AppVersion>("/app/versions/", body, {
        timeout: 0,
        onUploadProgress: (e) => {
          if (!onProgress || !e.total) return;
          onProgress(Math.round((e.loaded * 100) / e.total));
        },
      })
      .then((r) => r.data);
  },
  forceUpdate: (id: string) =>
    api.post<AppVersion>(`/app/versions/${id}/force-update/`).then((r) => r.data),
};
